// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const LoginPageCTA = styled(Button)`
  display: block;
  width: 100%;
  background: #594ff4;
  border-radius: 72px;
  margin-right: 0 !important;
  font-size: 16px;
`;

export const LoginPageCTASecondary = styled(LoginPageCTA)`
  background: #F8F8F8;
  &:hover {
    background: #EEEEEE;
  };
  color: black;
`;
